import './App.css';
import Firestore from './Firestore';
import { useState, useEffect } from 'react';
import Question from './Question';
import NavBar from './NavBar';
import { useLocation } from 'react-router-dom';
import LegendCard from './LegendCard';
import ShowAnswersButton from './ShowAnswersButton';
import firebase from 'firebase/app';
import 'firebase/auth';

function App() {
	let [questions, setQuestions] = useState([]);
	let [showAnswers, setShowAnswers] = useState(false);
	let [misAnsweredQuestions, setMisAnsweredQuestions] = useState([]);
	const [examMode, setExamMode] = useState(false);

	const search = useLocation().search;
	const subjectId = new URLSearchParams(search).get('subject_id');
	const chapterId = new URLSearchParams(search).get('chapter_id');

	useEffect(() => {
		if (!subjectId) return;

		if (!chapterId) {
			fetchQuestionsForExam();
			setExamMode(true);
			return;
		}

		fetchQuestions();
		signInAnonymously();
	}, [subjectId, chapterId]);

	const signInAnonymously = async () => {
		const auth = firebase.auth();
		const user = await auth.signInAnonymously();
		const uid = user.user.uid;
		Firestore.incrementNumberOfUserSessions(uid, chapterId, subjectId);
	};

	const fetchQuestions = async () => {
		const fetchedQuestions = await Firestore.fetchChapterQuestions(subjectId, chapterId);

		setQuestions(fetchedQuestions);
	};

	const fetchQuestionsForExam = async () => {
		const fetchedQuestions = await Firestore.fetchExamQuestions(subjectId);

		setQuestions(fetchedQuestions);
	};

	const onClickShowAnswers = () => setShowAnswers(!showAnswers);

	return (
		<div className="App">
			{/* <NavBar onClickShowAnswers={onClickShowAnswers} showAnswers={showAnswers} /> */}

			<ShowAnswersButton
				className="individualShowAnswersButton"
				onClickShowAnswers={onClickShowAnswers}
				showAnswers={showAnswers}
			/>

			<div className="cardsContainer" style={{ marginTop: 40 }}>
				{/* <LegendCard insideCard /> */}

				{questions.map((question, index) => (
					<Question
						key={index}
						id={index}
						questionNumber={index}
						{...question}
						showAnswers={showAnswers}
						onMisAnswering={() => {
							setMisAnsweredQuestions([...misAnsweredQuestions, questions[index]]);
						}}
					/>
				))}

				{misAnsweredQuestions.length > 0 && (
					<h2 color="rgb(50, 50, 50)">Mis-answered questions</h2>
				)}

				{misAnsweredQuestions.map((question, index) => {
					const originalQuestionNumber = questions.indexOf(question);
					return (
						<Question
							key={originalQuestionNumber + 'mis-answered'}
							id={originalQuestionNumber + 'mis-answered'}
							questionNumber={originalQuestionNumber}
							{...question}
							showAnswers={showAnswers}
						/>
					);
				})}
			</div>
		</div>
	);
}

export default App;
